module.exports = __webpack_public_path__ + "static/media/palomino-7.ba51934a.jpg";